import { PipeTransform } from '@angular/core';
import { chain } from 'lodash';
var FirstErrorPipe = /** @class */ (function () {
    function FirstErrorPipe() {
    }
    FirstErrorPipe.prototype.transform = function (control) {
        return chain(control && control.errors)
            .keys()
            .sort()
            .first()
            .snakeCase()
            .toUpper()
            .value() || null;
    };
    return FirstErrorPipe;
}());
export { FirstErrorPipe };
